export interface FederalBuyersQueryKeyArgs {
  buyerIds: string[]
}

export interface FederalBuyerQueryKeyArgs {
  buyerId: string
}

export interface FederalBuyerSearchQueryKeyArgs {
  query: string
}

export const federalBuyerQueryKey = {
  buyer: (keyArgs: FederalBuyerQueryKeyArgs) =>
    ['federal-buyer', keyArgs.buyerId] as const,
}

export const federalBuyersQueryKey = {
  all: () => ['federal-buyers'] as const,
  buyers: (keyArgs: FederalBuyersQueryKeyArgs) =>
    ['federal-buyers', ...keyArgs.buyerIds.toSorted()] as const,
  search: (keyArgs: FederalBuyerSearchQueryKeyArgs) =>
    ['federal-buyers', keyArgs.query] as const,
}

export interface NaicsQueryKeyArgs {
  codes: string[]
}

export interface NaicsSearchQueryKeyArgs {
  query: string
}

export const naicsQueryKey = {
  all: () => ['naics'] as const,
  code: ({ code }: { code: string }) => ['naics', 'code', code] as const,
  codes: (keyArgs: NaicsQueryKeyArgs) =>
    ['naics', ...keyArgs.codes.toSorted()] as const,
  search: (keyArgs: NaicsSearchQueryKeyArgs) =>
    ['naics', keyArgs.query] as const,
}

export interface PscQueryKeyArgs {
  codes: string[]
}

export interface PscSearchQueryKeyArgs {
  query: string
}

export const pscQueryKey = {
  all: () => ['psc'] as const,
  code: ({ code }: { code: string }) => ['psc', 'code', code] as const,
  codes: (keyArgs: PscQueryKeyArgs) =>
    ['psc', ...keyArgs.codes.toSorted()] as const,
  search: (keyArgs: PscSearchQueryKeyArgs) => ['psc', keyArgs.query] as const,
}
